import React from "react";
import { Maybe, SanityCommunityfundApplicationForm } from "@graphql-types";
import DynamicFormView from "../formPermitRequester/dynamicFormView";

interface Props {
  data: Maybe<SanityCommunityfundApplicationForm> | undefined;
}

/** Community Fund Application form – uses shared dynamic form view (sections + form fields). */
function CommunityFundApplicationForm({ data }: Props) {
  if (data == null) return null;
  return <DynamicFormView formData={data} />;
}

export default CommunityFundApplicationForm;
